import { render } from "./ContributeLink.vue?vue&type=template&id=a43953be&scoped=true"
import script from "./ContributeLink.vue?vue&type=script&lang=js"
export * from "./ContributeLink.vue?vue&type=script&lang=js"

import "./ContributeLink.vue?vue&type=style&index=0&id=a43953be&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@4.5.5__webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a43953be"]])

export default __exports__